import type { NavGroup, NavItem } from './layoutNav';

/** Match react-router NavLink active rules for sidebar highlighting. */
export function isNavItemActive(pathname: string, item: NavItem): boolean {
  const href = item.href;
  if (item.end || href === '/') {
    return pathname === href;
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function findActiveNavGroupId(groups: NavGroup[], pathname: string): string | null {
  for (const group of groups) {
    if (group.items.some((item) => isNavItemActive(pathname, item))) {
      return group.id;
    }
  }
  return null;
}

export function groupHasActiveItem(group: NavGroup, pathname: string): boolean {
  return group.items.some((item) => isNavItemActive(pathname, item));
}
